import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Rotate Orbit"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-rotate-orbit',
    templateUrl: './icon-rotate-orbit.component.html',
    styleUrls: ['./icon-rotate-orbit.component.scss'],
    standalone: false
})
export class IconRotateOrbitComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
